import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Plus, Minus, ShoppingBag, ArrowRight, ArrowLeft } from 'lucide-react';
import Header from './components/Header3';
import Footer from './components/Footer3';

const Cart3 = () => {
    const navigate = useNavigate();
    const [showEmpty, setShowEmpty] = useState(false);

    const [cartItems, setCartItems] = useState([
        { id: 1, name: 'Royal Banarasi Lehenga', price: 49999, quantity: 1, size: 'M', color: 'Deep Maroon', image: 'https://images.pexels.com/photos/2681751/pexels-photo-2681751.jpeg?auto=compress&cs=tinysrgb&w=800' },
        { id: 2, name: 'Silk Chanderi Saree', price: 18500, quantity: 1, size: 'Free Size', color: 'Ivory Gold', image: 'https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg?auto=compress&cs=tinysrgb&w=800' },
        { id: 3, name: 'Gold Zardozi Sherwani', price: 32000, quantity: 2, size: 'L', color: 'Antique Gold', image: 'https://images.pexels.com/photos/3014853/pexels-photo-3014853.jpeg?auto=compress&cs=tinysrgb&w=800' },
    ]);

    const updateQuantity = (id, delta) => {
        setCartItems(items => items.map(item => item.id === id ? { ...item, quantity: Math.max(1, item.quantity + delta) } : item));
    };

    const removeItem = (id) => {
        setCartItems(items => items.filter(item => item.id !== id));
    };

    const subtotal = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
    const shipping = subtotal > 25000 ? 0 : 500;
    const total = subtotal + shipping;
    const isEmpty = showEmpty || cartItems.length === 0;

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&family=Lato:wght@300;400;700&display=swap');
            `}</style>

            <div style={{ fontFamily: "'Lato', sans-serif" }} className="min-h-screen bg-[#FFFDF7]">
                <Header cartCount={cartItems.length} />

                <main className="pt-24 pb-16 px-4 lg:px-8">
                    <div className="max-w-[1400px] mx-auto">
                        <div className="mb-10">
                            <p className="text-[#B8860B] text-xs font-bold tracking-[0.3em] uppercase mb-3">Shopping</p>
                            <h1 style={{ fontFamily: "'Playfair Display', serif" }} className="text-3xl lg:text-5xl font-bold text-[#722F37] tracking-wide">
                                Your Bag
                            </h1>
                        </div>

                        {isEmpty ? (
                            <div className="flex flex-col items-center justify-center py-24">
                                <div className="w-24 h-24 border border-[#E8E0D8] rounded-full flex items-center justify-center mb-8">
                                    <ShoppingBag className="w-10 h-10 text-[#6B7280]" />
                                </div>
                                <h2 style={{ fontFamily: "'Playfair Display', serif" }} className="text-2xl lg:text-3xl font-bold text-[#722F37] mb-3">
                                    Your bag is empty
                                </h2>
                                <p className="text-[#6B7280] text-sm mb-8 max-w-sm text-center">
                                    Discover our curated collections and find pieces that speak to your soul.
                                </p>
                                <button
                                    onClick={() => navigate('/template3/shop')}
                                    className="inline-flex items-center gap-2 px-8 py-3 text-sm font-bold tracking-wider uppercase transition-all duration-300"
                                    style={{ border: '1px solid #722F37', color: '#722F37', backgroundColor: 'transparent' }}
                                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#722F37'; e.currentTarget.style.color = '#FFFFFF'; }}
                                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#722F37'; }}
                                >
                                    Explore Collection <ArrowRight className="w-4 h-4" />
                                </button>
                            </div>
                        ) : (
                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
                                {/* Cart Items */}
                                <div className="lg:col-span-2 space-y-4">
                                    {cartItems.map(item => (
                                        <div key={item.id} className="flex gap-4 lg:gap-6 p-4" style={{ backgroundColor: '#FFFFFF', border: '1px solid #E8E0D8' }}>
                                            <div className="w-24 h-32 lg:w-32 lg:h-40 flex-shrink-0 overflow-hidden">
                                                <img src={item.image} alt={item.name} className="w-full h-full object-cover" />
                                            </div>
                                            <div className="flex-1 flex flex-col justify-between">
                                                <div>
                                                    <div className="flex justify-between items-start">
                                                        <h3 className="text-sm lg:text-base font-bold" style={{ color: '#1A1A1A' }}>{item.name}</h3>
                                                        <button onClick={() => removeItem(item.id)} className="p-1 transition-colors" style={{ color: '#6B7280' }} onMouseEnter={(e) => (e.currentTarget.style.color = '#722F37')} onMouseLeave={(e) => (e.currentTarget.style.color = '#6B7280')}>
                                                            <X size={18} />
                                                        </button>
                                                    </div>
                                                    <p className="text-xs mt-1" style={{ color: '#6B7280' }}>Size: {item.size} | Color: {item.color}</p>
                                                </div>
                                                <div className="flex items-center justify-between mt-4">
                                                    <div className="flex items-center" style={{ border: '1px solid #E8E0D8', display: 'inline-flex' }}>
                                                        <button onClick={() => updateQuantity(item.id, -1)} className="w-8 h-8 flex items-center justify-center" style={{ color: '#722F37' }}>
                                                            <Minus size={14} />
                                                        </button>
                                                        <span className="w-8 h-8 flex items-center justify-center text-xs font-bold" style={{ borderLeft: '1px solid #E8E0D8', borderRight: '1px solid #E8E0D8', color: '#1A1A1A' }}>
                                                            {item.quantity}
                                                        </span>
                                                        <button onClick={() => updateQuantity(item.id, 1)} className="w-8 h-8 flex items-center justify-center" style={{ color: '#722F37' }}>
                                                            <Plus size={14} />
                                                        </button>
                                                    </div>
                                                    <p className="text-base font-bold" style={{ color: '#B8860B' }}>
                                                        {`\u20B9${(item.price * item.quantity).toLocaleString('en-IN')}`}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    <button onClick={() => navigate('/template3/shop')} className="inline-flex items-center gap-2 text-sm font-bold mt-4 transition-colors" style={{ color: '#722F37' }}>
                                        <ArrowLeft className="w-4 h-4" /> Continue Shopping
                                    </button>
                                </div>

                                {/* Order Summary */}
                                <div className="lg:col-span-1">
                                    <div className="p-6" style={{ backgroundColor: '#FFF9F0', border: '1px solid #E8E0D8' }}>
                                        <h3 style={{ fontFamily: "'Playfair Display', serif" }} className="text-xl font-bold text-[#722F37] mb-6">
                                            Order Summary
                                        </h3>
                                        <div className="space-y-3 mb-6">
                                            <div className="flex justify-between text-sm">
                                                <span style={{ color: '#6B7280' }}>Subtotal</span>
                                                <span className="font-bold" style={{ color: '#1A1A1A' }}>{`\u20B9${subtotal.toLocaleString('en-IN')}`}</span>
                                            </div>
                                            <div className="flex justify-between text-sm">
                                                <span style={{ color: '#6B7280' }}>Shipping</span>
                                                <span className="font-bold" style={{ color: shipping === 0 ? '#B8860B' : '#1A1A1A' }}>
                                                    {shipping === 0 ? 'FREE' : `\u20B9${shipping}`}
                                                </span>
                                            </div>
                                            {shipping === 0 && (
                                                <p className="text-[11px]" style={{ color: '#B8860B' }}>Free shipping on orders above \u20B925,000</p>
                                            )}
                                        </div>
                                        <div className="flex justify-between py-4 mb-6" style={{ borderTop: '1px solid #E8E0D8' }}>
                                            <span className="font-bold" style={{ color: '#1A1A1A' }}>Total</span>
                                            <span className="text-xl font-bold" style={{ color: '#B8860B' }}>{`\u20B9${total.toLocaleString('en-IN')}`}</span>
                                        </div>
                                        <button
                                            onClick={() => navigate('/template3/checkout')}
                                            className="w-full py-4 text-sm font-bold tracking-[0.15em] uppercase inline-flex items-center justify-center gap-2 transition-all duration-300"
                                            style={{ backgroundColor: '#722F37', color: '#FFFFFF', border: '1px solid #722F37' }}
                                            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#5A1F2A'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#722F37'; }}
                                        >
                                            Proceed to Checkout <ArrowRight className="w-4 h-4" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default Cart3;
